import { Configure } from "react-instantsearch";
import PaletteHits from "../components/Hits/PaletteHits";
import InstantSearchWrapper from "../components/layout/Search/InstantSearchWrapper";
import PaletteCard, { PaletteCardProps } from "../components/PaletteCard/PaletteCard";
import Sort from "../components/Sort/Sort";
import { algoliaConfig } from "../data/config";



export default function Palettes() {
    return (
      <InstantSearchWrapper indexName={algoliaConfig.PALETTE_INDEX}>      
        <Configure hitsPerPage={30} />
        <div className={"fl-container__flex fl-container__flex--gap fl-container__content"} style={{ marginTop: "20px", marginBottom: "20px" }}> 
          <div className={"finish-sort__align-end"}>
            <Sort />
          </div>
          <PaletteHits />
        </div>
      </InstantSearchWrapper>
    )
}